import { render, staticRenderFns } from "./SharepointModal.vue?vue&type=template&id=c97248b4&scoped=true&lang=pug&"
import script from "./SharepointModal.vue?vue&type=script&lang=js&"
export * from "./SharepointModal.vue?vue&type=script&lang=js&"
import style0 from "./SharepointModal.vue?vue&type=style&index=0&id=c97248b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97248b4",
  null
  
)

export default component.exports